import { Input,
         OnInit,
         Renderer,
         Component,
         ElementRef }          from '@angular/core';
import { FormGroup }           from '@angular/forms';
import { ViewChild }           from '@angular/core';
import { ModalDirective }      from 'ng2-bootstrap/modal';
import { ModalOptions }        from 'ng2-bootstrap/modal';
import { DynamicFormService }  from '../../dynamic-form.service';

@Component({
  selector: 'ing-edit-modal',
  templateUrl: './edit-modal.component.html',
  styleUrls: ['./edit-modal.component.scss'],
  providers: [DynamicFormService]
})
export class EditModalComponent implements OnInit {
  @Input('modal-size')    modalSize: string = 'modal-lg';
  @ViewChild('formModal') formModal: ModalDirective;

  formTitle: string;
  headerClass: string;
  acceptBtnClass: string;
  formName: string;
  inputs: any;
  groups: Array<{id: string, title: string, class: string, classContainer: string, order: number}>;
  form: FormGroup;

  resolve: any;
  reject: any;

  constructor(
    protected dfs: DynamicFormService,
    protected _element: ElementRef,
    protected _renderer: Renderer
  ) { }

  ngOnInit() {
    this.form     = new FormGroup({});
    this.inputs   = [];
    this.formName = 'form';

    this.formModal.config = {
      keyboard: false,
      ignoreBackdropClick: true
    };
  }

  closeFormModal() {
    this.formModal.hide();

    const body = document.getElementsByClassName('theme-imm')[0];

    body.className = 'theme-imm smooth-scroll';

    this.reject('Cancelado por el usuario');
  }

  onSubmit($event) {
    this.formModal.hide();

    const body = document.getElementsByClassName('theme-imm')[0];

    body.className = 'theme-imm smooth-scroll';

    this.resolve(this.form.value);
  }

  show(options: any) {
    this.formTitle      = options.formTitle;
    this.headerClass    = options.headerClass;
    this.acceptBtnClass = options.acceptBtnClass;
    this.inputs         = options.inputs;
    this.groups         = options.groups || null;
    this.form           = this.dfs.toGroup(this.inputs);

    const body = document.getElementsByClassName('theme-imm')[0];

    body.className = 'theme-imm';

    return new Promise((resolve, reject) => {
      this.formModal.show();

      this.resolve = resolve;
      this.reject  = reject;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/edit-modal/edit-modal.component.ts